export const ALLOCATION_WINDOWS_LIST = "ALLOCATION_WINDOWS_LIST";
export const ALLOCATION_WINDOWS_CREATE = "ALLOCATION_WINDOWS_CREATE";
export const ALLOCATION_WINDOWS_UPDATE = "ALLOCATION_WINDOWS_UPDATE";
export const ALLOCATION_WINDOWS_DELETE = "ALLOCATION_WINDOWS_DELETE";
export const ALLOCATION_WINDOWS_SHOW = "ALLOCATION_WINDOWS_SHOW";
export const ALLOCATION_WINDOWS_HISTORY = "ALLOCATION_WINDOWS_HISTORY";
export const ALLOCATION_WINDOWS_STATUS_LIST = "ALLOCATION_WINDOWS_STATUS_LIST";
